// extracted by mini-css-extract-plugin
export default {"text":"styles_text__r3j3q"};